import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif", // Replace 'Poppins' with your desired font family
  },
});
